import axios from 'axios';

export default function (
  data: Record<string, unknown>,
): Promise<[string, string]> {
  const { username, password } = data;

  return new Promise((resolve, reject) =>
    axios
      .post('/api/login', { username, password })
      .then((res) => {
        const { access_token, refresh_token } = res.data;
        resolve([access_token, refresh_token]);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          if (error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
          reject(new Error(error.response.data.msg));
        }

        if (!error.status) {
          reject(new Error('Unable to connect to the network!'));
        }

        reject(new Error('Call to api failed for some reason!'));
      }),
  );
}
